import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import ProfileAccountBalance from './ProfileAccountBalance';
import ProfileMenuContainer from './ProfileMenuContainer';
import ProfileMenuExit from './ProfileMenuExit';
type ProfileMenuProps = {
	visible: boolean;
	onClickUrl: () => void;
	inverse?: boolean;
};
const ProfileMenu = ({ visible = false, onClickUrl, inverse }: ProfileMenuProps) => {
	const navigate = useNavigate();
	return (
		<ProfileMenuContainer visible={visible}>
			<div className="profile-menu-content-p1">
				<ProfileAccountBalance />
				<hr style={{ width: '100%' }} />
				<div
					className="menu-item pointer"
					onClick={() => {
						navigate('/account/personal-data');
						onClickUrl && onClickUrl();
					}}
				>
					<FormattedMessage id="profile.my.account" />
				</div>
				<div
					className="menu-item pointer"
					onClick={() => {
						navigate('/account/movements-list');
					}}
				>
					<FormattedMessage id="movements" />
				</div>
				<div
					className="menu-item pointer"
					onClick={() => {
						navigate('/account/deposit');
					}}
				>
					<FormattedMessage id="payments" />
				</div>
			</div>
			<ProfileMenuExit />
		</ProfileMenuContainer>
	);
};

export default ProfileMenu;
